export type Theme = "light" | "dark" | "system";

const KEY = "pf-theme";
const DARK_QUERY = "(prefers-color-scheme: dark)";

export function getTheme(): Theme {
  try {
    return (localStorage.getItem(KEY) as Theme | null) ?? "system";
  } catch {
    return "system";
  }
}

function paint(dark: boolean) {
  const root = document.documentElement;
  root.classList.toggle("dark", dark);
  root.style.colorScheme = dark ? "dark" : "light";
  // theme-init.js paints the page background before the stylesheet loads; the CSS owns it from here
  root.style.backgroundColor = "";
}

export function applyTheme(theme: Theme) {
  paint(theme === "dark" || (theme === "system" && matchMedia(DARK_QUERY).matches));

  try {
    if (theme === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, theme);
  } catch {
    // ignore
  }
}

/**
 * With the "System" theme, follow the operating system when it switches
 * between light and dark while the app is open. Called once at startup.
 */
export function followSystemTheme() {
  const media = matchMedia(DARK_QUERY);
  media.addEventListener("change", (e) => {
    if (getTheme() === "system") paint(e.matches);
  });
}
